module.exports = __webpack_public_path__ + "img/icon-home-ev-02.3b62a77b.png";